import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { ReportStatusPipe } from './pipes/report-status.pipe';
import { PricePipe } from './pipes/price.pipe';

@NgModule({
  declarations: [PaymentStatusPipe, ReportStatusPipe, PricePipe, ConfirmationModalComponent],
  exports: [PaymentStatusPipe, ReportStatusPipe, PricePipe, RouterModule],
  imports: [CommonModule, ModalModule.forRoot()],
})
export class SharedModule {}
